export default "__VITE_ASSET__CR6vOj6V__"